import { render, staticRenderFns } from "./xiaohei_deposit_record_list.vue?vue&type=template&id=3d0baac2&scoped=true"
import script from "./xiaohei_deposit_record_list.vue?vue&type=script&lang=js"
export * from "./xiaohei_deposit_record_list.vue?vue&type=script&lang=js"
import style0 from "./xiaohei_deposit_record_list.vue?vue&type=style&index=0&id=3d0baac2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0baac2",
  null
  
)

export default component.exports